import React, { Component } from 'react'
import homeActions from './homeActions'
import './home.css'

const HEARTBEAT_MS = 30000
const YOUTUBE_URL = 'https://www.youtube.com/channel/UCFIkxWFrlwkuYSWI06IPeCg/live'
const ICECAST_URL = 'http://media.lunacast.com:9009/lunacast.m3u'
const SL_URL = 'https://maps.secondlife.com/secondlife/Dimidiata/44/147/321/'
const SL_LOCATION = 'Dimidiata (44,147,321)'

class Home extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentVideoIdx: 0,
      heartbeatIntervalId: null,
      config: {
        onTheEther: false,
        videos: []
      }
    }
    this.onNextClick = this.onNextClick.bind(this)
    this.loadVideos = this.loadVideos.bind(this)
  }

  componentDidMount () {
    // fire this ASAP
    if (this.state.config.videos.length === 0) {
      this.loadVideos()
    }

    // and set up a heartbeat
    const heartbeatIntervalId = setInterval(() => {
      this.loadVideos()
    }, HEARTBEAT_MS)
    this.setState({ heartbeatIntervalId })
  }

  componentWillUnmount () {
    const { heartbeatIntervalId } = this.state
    if (heartbeatIntervalId) {
      clearInterval(heartbeatIntervalId)
    }
  }

  loadVideos () {
    homeActions.getVideos().then((config) => {
      this.setState({ config })
    })
  }

  onNextClick () {
    let newIdx = this.state.currentVideoIdx + 1
    if (!this.state.config.videos[newIdx]) {
      newIdx = 0
    }
    this.setState({currentVideoIdx: newIdx})
  }

  renderVideoPlayer (state) {
    const { config: { videos }, currentVideoIdx } = state
    const videoHref = `${videos[currentVideoIdx]}/?controls=1&showinfo=0`

    return (
      <div className="home">
        <div className="home-header">
          <div className="external-links">
            [ <a href="https://www.facebook.com/fullmoontechno" target="_blank">Facebook</a> ] [ <a href="https://soundcloud.com/tinisi" target="_blank">Soundcloud</a> ] [ <a href="http://cdbaby.com/all/tinisi" target="_blank">CD Baby</a> ]
          </div>
        </div>
        <div className="home-body">
          <iframe className="video" src={videoHref} allowFullScreen="allowFullScreen" />
          <button className="forward-button" onClick={this.onNextClick} >New Video</button>
          <p>LunaCast is an ongoing series of live music events by the band robots.txt. On select full moon evenings we stream live audio and video from our home studio and put on a stage show in the virtual world of Second Life.</p>
        </div>
      </div>
    )
  }

  renderOnTheEther () {
    return (
      <div className="container">
        <div className="row">
          <div className="12 columns on-the-ether-header">
            <h3>We are on the ether!</h3>
            <h3>8:00 PM to 10:00 PM CST (GMT-6) (maybe later?)</h3>
          </div>
        </div>
        <div className="row on-the-ether-row">
          <div className="12 columns">
            <a href={YOUTUBE_URL} className="button on-the-ether-button" target="_blank">Live Video Stream</a>
          </div>
        </div>
        <div className="row on-the-ether-row">
          <div className="6 columns">
            <p className="on-the-ether-copy">
              This YouTube live stream is "the main event," I'll be using the comments here to check in on y'all during the show!
            </p>
          </div>
        </div>
        <div className="row on-the-ether-row">
          <div className="six columns">
            <a href={ICECAST_URL} className="button on-the-ether-button">Live Audio Stream</a>
            <p className="on-the-ether-copy">
              If you are short on bandwidth, or just want to listen! This audio stream should open in iTunes or whatever player you have.
            </p>
          </div>
          <div className="six columns">
            <a href={SL_URL} className="button on-the-ether-button">LunaCast MoonBase</a>
            <p className="on-the-ether-copy">
              Good news! Looks like they fixed the in world video issue. The YouTube stream is showing up great from the MoonBase. I will be in world, but multi-tasking, sorry in advance if I am not very interactive.
            </p>
          </div>
        </div>
        <div className="row on-the-ether-footer-row">
          <div className="12 columns">
            <p className="on-the-ether-copy">
              The YouTube stream address is:<br />
              <em>{`${YOUTUBE_URL}`}</em>
            </p>
            <p className="on-the-ether-copy">
              The Icecast audio stream address is:<br />
              <em>{`${ICECAST_URL}`}</em>
            </p>
            <p className="on-the-ether-copy">
              The LunaCast MoonBase is at:<br />
              <em>{`${SL_LOCATION}`}</em>
            </p>
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { config: { onTheEther } } = this.state
    return onTheEther ? this.renderOnTheEther() : this.renderVideoPlayer(this.state)
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/home.js